import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useContext, useState } from 'react';
// Create the context
var UpdateContext = createContext(undefined);
export var UpdateProvider = function (_a) {
    var children = _a.children;
    var _b = useState(null), updateRowData = _b[0], setUpdateRowData = _b[1];
    var isUpdateMode = updateRowData !== null;
    var clearUpdateData = function () {
        setUpdateRowData(null);
    };
    var value = {
        updateRowData: updateRowData,
        setUpdateRowData: setUpdateRowData,
        isUpdateMode: isUpdateMode,
        clearUpdateData: clearUpdateData,
    };
    return _jsx(UpdateContext.Provider, { value: value, children: children });
};
// Custom hook to use the context
export var useUpdateContext = function () {
    var context = useContext(UpdateContext);
    if (!context) {
        throw new Error('useUpdateContext must be used within an UpdateProvider');
    }
    return context;
};
